var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('container-item-wrapper', {
    attrs: {
      "widget": _vm.widget
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.widget.options.hidden),
      expression: "!widget.options.hidden"
    }],
    staticClass: "sub-form-container"
  }, [_c('el-row', {
    staticClass: "header-row"
  }, [_c('div', {
    staticClass: "action-header-column"
  }, [_c('span', {
    staticClass: "action-label"
  }, [_vm._v(_vm._s(_vm.i18nt('render.hint.subFormAction')))]), _vm._v(" "), (!_vm.isReadMode) ? _c('el-button', {
    staticClass: "action-button",
    attrs: {
      "disabled": _vm.widgetDisabled || _vm.actionDisabled || _vm.insertDisabled,
      "round": "",
      "type": "primary",
      "size": "mini",
      "title": _vm.i18nt('render.hint.subFormAddActionHint')
    },
    on: {
      "click": _vm.addSubFormRow
    }
  }, [_vm._v("\n          " + _vm._s(_vm.i18nt('render.hint.subFormAddAction'))), _c('i', {
    staticClass: "el-icon-plus el-icon-right"
  })]) : _vm._e()], 1)]), _vm._v(" "), _vm._l((_vm.rowIdData), function(subFormRowId, sfrIdx) {
    return _c('div', {
      key: subFormRowId,
      staticClass: "sub-form-row"
    }, [(_vm.leftActionColumn) ? _c('div', {
      staticClass: "sub-form-action-column hide-label"
    }, [_c('div', {
      staticClass: "action-button-column"
    }, [_c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isReadMode),
        expression: "!isReadMode"
      }],
      attrs: {
        "disabled": _vm.widgetDisabled || _vm.actionDisabled || _vm.insertDisabled,
        "circle": "",
        "type": "",
        "icon": "el-icon-circle-plus-outline",
        "title": _vm.i18nt('render.hint.insertSubFormRow')
      },
      on: {
        "click": function($event) {
          return _vm.insertSubFormRow(sfrIdx)
        }
      }
    }), _vm._v(" "), _c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isReadMode),
        expression: "!isReadMode"
      }],
      attrs: {
        "disabled": _vm.widgetDisabled || _vm.actionDisabled || _vm.deleteDisabled,
        "circle": "",
        "type": "",
        "icon": "el-icon-delete",
        "title": _vm.i18nt('render.hint.deleteSubFormRow')
      },
      on: {
        "click": function($event) {
          return _vm.deleteSubFormRow(sfrIdx)
        }
      }
    }), _vm._v(" "), (_vm.widget.options.showRowNumber) ? _c('span', {
      staticClass: "row-number-span"
    }, [_vm._v("#" + _vm._s(sfrIdx + 1))]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (!_vm.leftActionColumn && _vm.widget.options.showRowNumber) ? _c('div', {
      staticClass: "row-no-column"
    }, [(_vm.widget.options.showRowNumber) ? _c('span', {
      staticClass: "row-number-span"
    }, [_vm._v("#" + _vm._s(sfrIdx + 1))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "grid-sub-form-data-row"
    }, [_vm._l((_vm.widget.widgetList), function(subWidget, swIdx) {
      return [_c(_vm.getComponentByContainer(subWidget), {
        key: _vm.widgetSchemaData[sfrIdx][swIdx].id,
        tag: "component",
        attrs: {
          "widget": _vm.widgetSchemaData[sfrIdx][swIdx],
          "parent-list": _vm.widget.widgetList,
          "index-of-parent-list": swIdx,
          "parent-widget": _vm.widget,
          "sub-form-row-id": subFormRowId,
          "sub-form-row-index": sfrIdx,
          "sub-form-col-index": swIdx
        }
      })]
    })], 2), _vm._v(" "), (!_vm.leftActionColumn) ? _c('div', {
      staticClass: "sub-form-action-column hide-label"
    }, [_c('div', {
      staticClass: "action-button-column"
    }, [_c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isReadMode),
        expression: "!isReadMode"
      }],
      attrs: {
        "disabled": _vm.widgetDisabled || _vm.actionDisabled || _vm.insertDisabled,
        "circle": "",
        "type": "",
        "icon": "el-icon-circle-plus-outline",
        "title": _vm.i18nt('render.hint.insertSubFormRow')
      },
      on: {
        "click": function($event) {
          return _vm.insertSubFormRow(sfrIdx)
        }
      }
    }), _vm._v(" "), _c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isReadMode),
        expression: "!isReadMode"
      }],
      attrs: {
        "disabled": _vm.widgetDisabled || _vm.actionDisabled || _vm.deleteDisabled,
        "circle": "",
        "type": "",
        "icon": "el-icon-delete",
        "title": _vm.i18nt('render.hint.deleteSubFormRow')
      },
      on: {
        "click": function($event) {
          return _vm.deleteSubFormRow(sfrIdx)
        }
      }
    })], 1)]) : _vm._e()])
  })], 2)])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f356436a","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-render/container-item/grid-sub-form-item.vue
// module id = null
// module chunks = 